<template>
    <div class="datetime">
        <v-menu
            v-model="display"
            ref="menu"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :close-on-content-click="false"
            v-if="!fixed"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :background-color="backgroundColor"
                    :clearable="clearable && !readonly && !disabled"
                    :dense="dense"
                    :error-messages="errorMessages"
                    :flat="flat"
                    :label="required ? label + ' (*)' : label"
                    :outlined="outlined"
                    :prepend-inner-icon="prependInnerIcon"
                    :value="pretty_date"
                    :hide-details="hideDetails"
                    v-bind="attrs"
                    v-on="readonly || disabled ? {} : on"
                    @change="setNewDate($event)"
                    :placeholder="placeholder"
                    :readonly="readonly"
                    :disabled="disabled"

                ></v-text-field>
            </template>

            <v-date-picker
                v-model="inputVal"
                view-mode="year"
                no-title
                scrollable
                :first-day-of-week="1"
                :min="minDate"
                :max="maxDate"
                @input="display = false"
                :width="width"
                :disabled="disabled"
            >
            </v-date-picker>
        </v-menu>
        <template v-else>
            <v-date-picker
                :value="inputVal || $moment().format('YYYY-MM-DD')"
                @input="inputVal = $event"
                view-mode="year"
                no-title
                scrollable
                :first-day-of-week="1"
                :min="minDate"
                :max="maxDate"
                class="px-0"
                :width="width"
                :disabled="disabled"
                :key="inputVal"
            >
            </v-date-picker>
        </template>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        minDate: {
            default: () => moment().format("YYYY-MM-DD"),
        },
        maxDate: {
            default: null,
        },
        dateFormat: {
            type: String,
            default: "ll",
        },
        value: {
            required: false,
        },
        errorMessages: {
            required: false,
        },
        label: {
            type: String,
            required: true,
        },
        fixed: {
            type: Boolean,
            required: false,
            default: false,
        },
        required: {
            type: Boolean,
            required: false,
        },
        width: {
            type: Number,
            required: false,
        },
        prependInnerIcon: {
            type: String,
            required: false,
        },
        outlined: {
            type: Boolean,
            required: false,
        },
        flat: {
            type: Boolean,
            required: false,
            default: false,
        },
        dense: {
            type: Boolean,
            required: false,
            default: false,
        },
        backgroundColor: {
            type: String,
            required: false,
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        hideDetails: { 
            type: [Boolean, String],
            default: false,
        },
    },
    data() {
        return {
            inputVal: this.value,
            display: false,
        };
    },
    computed: {
        pretty_date() {
            if (!this.inputVal) {
                return null;
            }
            return this.$moment(this.inputVal).format(this.dateFormat);
        },
    },
    methods: {
        buildParseFormats() {
            const displayOnlyFormats = new Set([
                "ll",
                "LL",
                "lll",
                "LLL",
                "l",
                "LT",
                "LTS",
            ]);
            const formats = [
                moment.localeData().longDateFormat("L"),
                "DD/MM/YYYY",
                "D/M/YYYY",
                "DD/MM/YY",
                "DD-MM-YYYY",
                "YYYY-MM-DD",
                "YYYY/MM/DD",
            ];
            if (this.dateFormat && !displayOnlyFormats.has(this.dateFormat)) {
                formats.unshift(this.dateFormat);
            }
            return [...new Set(formats)];
        },
        setNewDate(date) {
            const raw = date == null ? "" : String(date).trim();
            if (!raw) {
                this.$emit("input", null);
                return;
            }

            const newDate = moment(raw, this.buildParseFormats(), true);
            if (newDate.isValid()) {
                const isoDate = newDate.format("YYYY-MM-DD");
                this.inputVal = isoDate;
                this.$emit("input", isoDate);
            } else {
                this.$emit("input", null);
            }
        },
    },
    watch: {
        value(val) {
            this.inputVal = val;
        },
        inputVal(val) {
            this.$emit("input", val);
        },
        display(isOpen) {
            if (isOpen && (this.readonly || this.disabled)) {
                this.display = false;
            }
        },
    },
};
</script>
